export const btnStyle = {
  "&:hover": { color: "#D53535", cursor: "pointer" },
};

export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
export const backgroundStyle = {
  backgroundColor: "#c8c3cc",
  minHeight: "100vh",
  margin: 0,
};
export const background = {
  backgroundColor: "#c8c3cc",
  color: "#060608",
  minHeight: "100vh",
  margin: 0,
};
